export default class FilterGroupToggle {
    static key = 'FilterGroupToggle';

    constructor(el) {
        this.el = el;
        this.filterTitles = this.el.querySelectorAll('.js-toggle-filters');

        this.init();
    }

    init() {
        this.filterTitles.forEach((title) => {
            title.addEventListener('click', this.onFilterTitleClick.bind(this));
        });
    }

    onFilterTitleClick(e) {
        const btn = e.currentTarget;
        const group = btn.parentElement;
        const list = group.querySelector('.js-filters-list');
        list.classList.toggle('is-open');
    }
}
